import { getProductFromSessionStorage } from "src/utils/storage/auth";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import {
  MAX_LICENSE_COUNT,
  getMinLicenseCount,
} from "src/utils/pay/licenseCount";

const useValidationSchemas = ({
  type,
  cloudProvider,
}: {
  type: "create" | "update";
  cloudProvider: "AWS" | "OCI";
}) => {
  const { t } = useTranslation();
  const couponCodeSchema = {
    couponCode: Yup.string().optional(),
  };
  // 사용자 수는 금액에 직접 반영되므로 범위/정수 여부까지 검증한다.
  // (최종 검증은 서버 책임 — 클라이언트는 오조작 방지 목적)
  const minLicenseCount = getMinLicenseCount(cloudProvider === "OCI");
  const commonRequestSchema = {
    licenseCount: Yup.number()
      .typeError("사용자 수를 입력해주세요")
      .integer("사용자 수는 정수만 입력할 수 있습니다")
      .min(minLicenseCount, `최소 ${minLicenseCount}명부터 구매할 수 있습니다`)
      .max(
        MAX_LICENSE_COUNT,
        `최대 ${MAX_LICENSE_COUNT.toLocaleString()}명까지 구매할 수 있습니다`
      )
      .required("필수 항목입니다"),
    payTerm: Yup.string().required("필수 항목입니다"),
    totalPrice: Yup.number().required("필수 항목입니다"),
    serviceUid: Yup.string(),
    billType: Yup.string(),
    billCode: Yup.string(),
    nxacAppUids: Yup.mixed(),
    payDate: Yup.string(),
    // 약관 동의는 결제 진행의 필수 조건 — isValid에 반영되도록 스키마에 포함
    confirmPolicy: Yup.boolean().oneOf([true], "필수 항목입니다"),
    companyName: Yup.string().optional(),
    referralId: Yup.string().optional(),
    upc: Yup.string().optional(),
    taxInvoice: Yup.mixed().optional(),
    couponCode: Yup.string()
      .matches(/^[A-Z0-9]*$/, "영문과 숫자만 입력할 수 있습니다.")
      .max(20, "최대 20자까지 입력할 수 있습니다."),
  };
  // 현금결제 요청
  const requestCashSchema = {
    ...commonRequestSchema,
    depositor: Yup.string().required("필수 항목입니다"),
  };
  // 카드결제 요청 (INICIS)
  const requestCardSchema = {
    ...commonRequestSchema,
  };
  if (
    cloudProvider === "OCI" &&
    getProductFromSessionStorage() === "WRAPSODY"
  ) {
    // 업데이트 시 일부 필수 아님 처리 가능
    // requestCashSchema.couponCode = Yup.string().optional();
    requestCashSchema.companyName = Yup.string()
      .max(50)
      .required(t("logIn.enterCompanyName"));
    requestCardSchema.companyName = Yup.string()
      .max(50)
      .required(t("logIn.enterCompanyName"));
  }

  return {
    requestCashSchema: Yup.object().shape(requestCashSchema),
    requestCardSchema: Yup.object().shape(requestCardSchema),
  };
};

export default useValidationSchemas;
